import { render, staticRenderFns } from "./ws3-area-full-people.vue?vue&type=template&id=0744f80e"
import script from "./ws3-area-full-people.vue?vue&type=script&lang=js"
export * from "./ws3-area-full-people.vue?vue&type=script&lang=js"
import style0 from "./ws3-area-full-people.vue?vue&type=style&index=0&id=0744f80e&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports